<template>
    <div class="d-flex justify-content-center align-items-center h-100">
        <div>
            <div class="d-flex justify-content-center mb-5">
                <div class="spinner">
                    <div class="double-bounce1"></div>
                    <div class="double-bounce2"></div>
                </div>
            </div>
            <h5>در حال انتقال به درگاه پرداخت</h5>
        </div>
        <form id="redirectForm" :action="gatewayData.url" method="post" enctype="multipart/form-data">
            <input v-for="(item, index) in gatewayData.form" :key="index" type="hidden" :value="item.value"
                :name="item.key">
        </form>
    </div>
</template>

<script>
export default {
    name: 'redirectToGateway',
    layout: 'provider',
    data() {
        return {
            gatewayData: {
                form: [],
                transportType: 0,
                url: null
            },
        };
    },
    methods: {
        handleRedirectToGateway() {
            this.gatewayData = JSON.parse(localStorage.getItem("gatewayData"));
            localStorage.removeItem("gatewayData");
            setTimeout(function () {
                document.getElementById('redirectForm').submit()
            }, 1000);
        }
    },
    mounted() {
        this.handleRedirectToGateway();
    },
}
</script>

<style>
.spinner {
    width: 95px;
    height: 95px;
    position: relative;
}

.double-bounce1,
.double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #7367f0;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;

    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
    animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {

    0%,
    100% {
        -webkit-transform: scale(0.0)
    }

    50% {
        -webkit-transform: scale(1.0)
    }
}

@keyframes sk-bounce {

    0%,
    100% {
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
    }

    50% {
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
    }
}
</style>
